import React, { Component } from 'react';

import { Card as ReactCard, CardBody } from 'reactstrap';
import styled from '@emotion/styled';

class Card extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { body, className, bodyClassName } = this.props;
    return (
      <ReactCard className={className || ''}>
        <CardBody className={bodyClassName || ''}>{body}</CardBody>
      </ReactCard>
    );
  }
}

const CardStyle = styled(Card)`
  border: none;
  box-shadow: 0 2px 10px 0 rgba(164, 164, 172, 0.2);
`;

export default CardStyle;



// WEBPACK FOOTER //
// ./src/components/helpers/Card.js